import React, { useState } from "react";
import "./App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Homepage from "./Pages/Homepage";
import Services from "./Pages/Services";
import ClientWork from "./Pages/ClientWork";
import ProjectPage from "./Pages/[slug]"; // Change this import
import AdminRoute from "./Components/admin/AdminRoute";
import "./firebase";
import ProcessSection from "./Components/ProcessSection";
import ROI from "./Pages/ROI";
import useInitAudio from "./Components/useInitAudio";
import AudioInitialiser from "./Components/AudioInitialiser";
import SoundBoard from "./Pages/Soundboard";
import BlogPage from "./Pages/BlogPage";
import BlogPost from "./Pages/BlogPost";
import OnboardingForm from "./Components/OnboardingForm/OnboardingForm";
import Contact from "./Pages/Contact";
import BrandProfile from "./Pages/BrandProfile/BrandProfile";
import RouteDebugger from "./Components/RouteDebugger";
import BrandProfileEditor from "./Components/admin/BrandProfileEditor";
import TestQuestionnaire from "./Pages/TestQuestionnaire"; // Import the test questionnaire page
import TestAdmin from "./Pages/TestAdmin"; // Import the test admin page
import TestEditor from "./Pages/TestEditor"; // Import the test editor page
import ProfilePreviewPage from "./Pages/ProfilePreviewPage";
import DynamicBrandPage from "./Pages/DynamicBrandPage"; // Import the new DynamicBrandPage
import PrivacyPolicy from "./Pages/PrivacyPolicy";

function App() {
  const [debug, setDebug] = useState(false);
  useInitAudio();
  return (
    <HelmetProvider>
      <Router>
        {debug && <RouteDebugger />}
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: "#333",
              color: "#fff",
            },
          }}
        />
        {/* <AudioInitialiser /> */}
        <Routes>
          <Route path="/" element={<ClientWork />} />
          <Route path="/home" element={<Homepage />} />
          <Route path="/client-work" element={<ClientWork />} />
          <Route path="/work/:slug" element={<ProjectPage />} />{" "}
          <Route path="/process" element={<ProcessSection />} /> //
          <Route path="/soundboard" element={<SoundBoard />} />
          <Route path="/about" element={<Homepage />} />
          <Route path="/roi" element={<ROI />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:postId" element={<BlogPost />} />
          <Route path="/admin/*" element={<AdminRoute />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/onboarding" element={<OnboardingForm />} />
          <Route path="/brand-profile/:profileId" element={<BrandProfile />} />
          <Route
            path="/admin/brand-profiles/:profileId/edit"
            element={<BrandProfileEditor />}
          />
          {/* New direct route to DynamicBrandPage */}
          <Route path="/brand-page" element={<DynamicBrandPage />} />
          <Route
            path="/brand-page/:appendedName"
            element={<DynamicBrandPage />}
          />
          <Route path="/test" element={<TestQuestionnaire />} />
          <Route path="/test-admin" element={<TestAdmin />} />
          <Route path="/test-editor" element={<TestEditor />} />
          <Route
            path="/questionnaire-editor/:questionnaireId/response/:responseId"
            element={<TestEditor />}
          />
          <Route
            path="/profile-preview/response/:responseId"
            element={<ProfilePreviewPage />}
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
